import { BrowserRouter, Route, Switch } from "react-router-dom";
import HomeComponent from "./Components/home-page/home-component";
import Error from "./Components/errorPage";
import ProjectDetails from "./Components/home-page/government-projects/project-details-component";
import ProjectsList from "./Components/home-page/government-projects/government-projects-list-component";
import NewsDetails from "./Components/home-page/news/news-details";
import Main_navbar from "./main-navbar";
import TouristHome from "./Components/tourist-page/tourist-home-page";
import EServices from "./Components/home-page/citizen-services/sevices-pages/E-Services";
import news_list from "./Components/home-page/news/news_list";
import FilterNews from "./Components/home-page/news/filter-news";
import EServiceDirectories from "./Components/home-page/citizen-services/sevices-pages/E-Services-Directory";
import Directorates from "./Components/home-page/citizen-services/sevices-pages/Directorates-Services";
import EmergencyNumbers from "./Components/home-page/citizen-services/sevices-pages/Emergency-Numbers";
import Advertisements from "./Components/home-page/citizen-services/sevices-pages/Advertisements";
import HayaKarimaDetails from "./Components/home-page/good-life/haya-karima-details";
import ExConservatives from "./Components/Governer/ex-conservatives";
import TechnologyCenterServices from "./Components/home-page/citizen-services/sevices-pages/Technology-Center-Services";
import CitiesNavbar from "./Components/government-cities/cities-navbar";
import Leaders from "./Components/Governer/leaders";
import DocumentLibrary from "./Components/document-library-page/document-library";
import Appointment from "./Components/appointment/appointment";
import Tribe from "./Components/home-page/local-leaders/local-leaders-pages/tribe";
import Parliament from "./Components/home-page/local-leaders/local-leaders-pages/parliament";
import Senate from "./Components/home-page/local-leaders/local-leaders-pages/senate";
import AdvertismentList from "./Components/home-page/advertisment/advertisment-list";
import YouthEmp from "./Components/home-page/advertisment/youth-employent";
import Career from "./Components/home-page/advertisment/career";
import DocumentLibraryDetails from "./Components/document-library-page/document-library-details";
import Footer from "./Components/footer";
import VideosList from "./Components/home-page/videos/video-list-component";
import VideoDetails from "./Components/home-page/videos/video-details-component";
import PhotoDetails from "./Components/home-page/photo-album/photo-details-component";
import PhotosList from "./Components/home-page/photo-album/photos-list-component";
import FilterPhotos from "./Components/home-page/photo-album/filter-photos";
import AdvertismentDetails from "./Components/ads/adsDetails";
import FilterVideos from "./Components/home-page/videos/filter-videos";
import InvestorHome from "./Components/investor-page/investor-home-page";
import TouristAttractionDetails from "./Components/touristAttraction/touristAttractionDetails";
import Ads from "./Components/ads/ads";
import ServicesComponent from "./Components/services-component";
import AppointmentDetails from "./Components/appointment/appointment-details";
import AgendaList from "./Components/agenda/list-agenda";
import AgendaDetails from "./Components/agenda/agenda-details";
import investmentOpportunitiesList from "./Components/investor-page/investment-opportunities/investment-opportunities-list";
import OpportunitiesDetails from "./Components/investor-page/investment-opportunities/investment-opportunities-details";
import StaticContentHome from "./Components/static-content/static-content-home";
import CityDetails from "./Components/government-cities/city-details";
import OrgChartRender from "./Components/orgChart/orgChartRender";
import Contact from "./Components/home-page/contact_us";
import StockTicker from "./Components/news-ticker";
import ScrollToTop from "./scroll";
import CareerDetails from "./Components/home-page/advertisment/details/career-details";
import YouthDetails from "./Components/home-page/advertisment/details/youth-details";
import NationalCouncil from "./Components/home-page/local-leaders/local-leaders-pages/national-council";
import NationalCouncilDetails from "./Components/home-page/local-leaders/local-leaders-pages/details/national-council-details";
import SocietyDetails from "./Components/home-page/local-leaders/local-leaders-pages/details/society-details";
import Society from "./Components/home-page/local-leaders/local-leaders-pages/society";
import DirectoratesHome from "./Components/home-page/citizen-services/sevices-pages/Directorates-Services/directorates-services-home";
import YouthLeaders from "./Components/home-page/local-leaders/local-leaders-pages/youth-leaders";
import FamousStaticContentDetails from "./Components/home-page/government-famous/static-content-details";
import FilterAppointment from "./Components/appointment/filter-appointment";
import AudioPlayer from "./Components/ui/react-audio-player";
import Player from "./Components/ui/react-audio-player";
const AppRouting = () => {
  return (
    <BrowserRouter>
      <Main_navbar />
      <StockTicker />
      <ScrollToTop>
        <main className="main-route-content">
        <Switch>
          {/* home page*/}
          <Route exact path="/" component={HomeComponent} />
          <Route exact path="/home" component={HomeComponent} />
          <Route exact path="/contactus/:id" component={Contact} />
          {/* projects */}
          <Route exact path="/projectDetails/:id" component={ProjectDetails} />
          <Route exact path="/projectslist" component={ProjectsList} />
          {/* news */}
          <Route exact path="/newsdetails/:id" component={NewsDetails} />
          <Route exact path="/newslist" component={news_list} />
          <Route exact path="/filternews/:info" component={FilterNews} />
          {/* services */}
          <Route exact path="/eservices" component={EServices} />
          <Route exact path="/services/:typeid" component={ServicesComponent} />
          <Route
            exact
            path="/eservicesdirectories"
            component={EServiceDirectories}
          />
          <Route exact path="/directorates" component={Directorates} />
          <Route
            exact
            path="/directorates/:id/:name"
            component={DirectoratesHome}
          />
          <Route exact path="/emergencynumbers" component={EmergencyNumbers} />
        <Route exact path="/advertisements" component={Advertisements} />
          <Route
            exact
            path="/techcenterservices"
            component={TechnologyCenterServices}
          />
          {/* Videos */}
          <Route exact path="/videoslist" component={VideosList} />
          <Route exact path="/videodetails/:id" component={VideoDetails} />
          <Route exact path="/filtervideos/:info" component={FilterVideos} />
          {/* Photos */}
          <Route exact path="/photoslist" component={PhotosList} />
          <Route exact path="/photodetails/:id" component={PhotoDetails} />
          <Route exact path="/filterphotos/:info" component={FilterPhotos} />
          {/* Tourist */}
          <Route exact path="/tourist" component={TouristHome} />
          <Route
            exact
            path="/tourist-attraction-details/:id"
            component={TouristAttractionDetails}
          />
          {/* Investor */}
          <Route exact path="/investor" component={InvestorHome} />
          {/* Investor Opportunities */}
          <Route
            exact
            path="/opportunitiesdetails/:id"
            component={OpportunitiesDetails}
          />
          <Route
            exact
            path="/opportunitieslist"
            component={investmentOpportunitiesList}
          />
          {/* Static Content */}
          <Route
            exact
            path="/statichome/:id/:title/:code/:name"
            component={StaticContentHome}
          />
          {/* Gov Famous */}
          <Route
            exact
            path="/famousDetails/:id"
            component={FamousStaticContentDetails}
          />
          {/* Appointment */}
          <Route exact path="/appointment" component={Appointment}></Route>
          <Route
            exact
            path="/filterappointments/:info"
            component={FilterAppointment}
          />
          <Route
            exact
            path="/appointmentdetails/:id"
            component={AppointmentDetails}
          />
          {/* x-Conservatives */}
          <Route exact path="/exconservatives" component={ExConservatives} />
          <Route exact path="/leaders" component={Leaders}></Route>

          {/* Cities */}
          <Route exact path="/cities" component={CitiesNavbar} />
          <Route exact path="/citydetails/:id" component={CityDetails} />

          {/* Local Leaders */}
          <Route exact path="/tribe" component={Tribe} />
          <Route exact path="/nationalcouncil" component={NationalCouncil} />
          <Route
            exact
            path="/nationalcouncildetails/:id"
            component={NationalCouncilDetails}
          />
          <Route exact path="/society" component={Society} />
          <Route exact path="/societydetails/:id" component={SocietyDetails} />
          <Route exact path="/parliament" component={Parliament} />
          <Route exact path="/senate" component={Senate} />
          <Route exact path="/youthleaders" component={YouthLeaders} />

          {/* Good Life */}
          <Route
            exact
            path="/HayaKarimaDetails/:id"
            component={HayaKarimaDetails}
          />
          {/* Document Library */}
          <Route
            exact
            path="/document-library/:type"
            component={DocumentLibrary}
          ></Route>
          <Route
            exact
            path="/document-library-details/:id"
            component={DocumentLibraryDetails}
          />
          {/* Ads */}
          <Route exact path="/ads/:id" component={AdvertismentList}></Route>
          <Route
            exact
            path="/advertisment-details/:id"
            component={AdvertismentDetails}
          />
          <Route exact path="/youth" component={YouthEmp}></Route>
          <Route
            exact
            path="/youthdetails/:id"
            component={YouthDetails}
          ></Route>
          <Route exact path="/career" component={Career}></Route>
          <Route
            exact
            path="/careerdetails/:id"
            component={CareerDetails}
          ></Route>
          {/* Events */}
          <Route exact path="/eventlist" component={AgendaList} />
          <Route exact path="/eventdetails/:id" component={AgendaDetails} />
          <Route exact path="/filterevents/:info" component={AgendaList} />

          {/* Org Chart */}
          <Route exact path="/org-chart" component={OrgChartRender} />
          {/* <Route exact path="/player" component={Player} /> */}
          {/* Error */}
          <Route path="*" component={Error} />
        </Switch>
        </main>
      </ScrollToTop>

      {/* <Ads /> */}
      <Footer />
    </BrowserRouter>
  );
};

export default AppRouting;
